import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import './Speakers.css';
import bgImage from '../styles/img/backgroundNV1.png'; // Using the same background from event-planned/index.js

const Speakers = () => {
    const intl = useIntl();
    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    // Apply the same body class as the main event-planned view to keep consistent theme
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.classList.add('theme-event-planned');
        return () => {
            document.body.classList.remove('theme-event-planned');
        };
    }, []);

    // Get translations
    const title = intl.formatMessage({ id: 'eventPlannedSpeakersTitle', defaultMessage: 'Conferencistas' });
    const excerpt = intl.formatMessage({ id: 'eventPlannedSpeakersExcerpt', defaultMessage: '' });
    
    // Parse the speakers JSON array from strings
    const speakersString = intl.formatMessage({ id: 'eventPlannedSpeakersItems', defaultMessage: '[]' });
    let speakers = [];
    try {
        speakers = JSON.parse(speakersString);
    } catch (e) {
        console.error("Failed to parse speakers:", e);
    }

    const openModal = (item) => {
        setSelectedItem(item);
        setIsExpanded(false);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedItem(null);
    };

    const getImage = (imgPath) => {
        try {
            const cleanPath = imgPath.replace(/^\.\//, '');
            const req = require(`../styles/img/${cleanPath}`);
            return req.default || req;
        } catch (e) {
            console.error("Image not found:", imgPath);
            return '';
        }
    };

    return (
        <div className="supercontent home" id="myApp">
            <section className="herowelcome">
                <img className="bck" src={bgImage} alt="Background" />
                <div className="superboxponentes">
                    
                    {/* Modal */}
                    {showModal && selectedItem && (
                        <div className="speakers-modal" onClick={closeModal}>
                            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                <div className="boxclosemodal">
                                    <span className="close" onClick={closeModal}><i className="fa fa-times"></i></span>
                                </div>
                                <div className="infomodalponente">
                                    <div className="photomodalponente">
                                        <img src={getImage(selectedItem.imagen)} alt={selectedItem.nombre} />
                                    </div>
                                    <div className="principalmodalponente">
                                        <p className="namemodal" dangerouslySetInnerHTML={{ __html: selectedItem.nombre }}></p>
                                        <p className="ponenciamodal" dangerouslySetInnerHTML={{ __html: selectedItem.puesto }}></p>
                                    </div>
                                </div>
                                <div className="descmodalponente" style={{ display: 'block' }}>
                                    {(() => {
                                        const isEnglish = intl.locale && intl.locale.includes('en');
                                        const readMoreText = isEnglish ? 'Read more...' : 'Ver más...';
                                        const readLessText = isEnglish ? 'Show less' : 'Ver menos';
                                        
                                        const parts = selectedItem.descripcion.split('<br /><br />');
                                        if (parts.length <= 3) {
                                            return <p dangerouslySetInnerHTML={{ __html: selectedItem.descripcion }}></p>;
                                        }

                                        if (isExpanded) {
                                            return (
                                                <>
                                                    <p dangerouslySetInnerHTML={{ __html: selectedItem.descripcion }}></p>
                                                    <a href="#!" onClick={(e) => { e.preventDefault(); setIsExpanded(false); }} style={{ color: '#004765', fontWeight: 'bold', display: 'block', marginTop: '10px' }}>
                                                        {readLessText}
                                                    </a>
                                                </>
                                            );
                                        } else {
                                            const shortDesc = parts.slice(0, 3).join('<br /><br />');
                                            return (
                                                <>
                                                    <p dangerouslySetInnerHTML={{ __html: shortDesc }}></p>
                                                    <a href="#!" onClick={(e) => { e.preventDefault(); setIsExpanded(true); }} style={{ color: '#004765', fontWeight: 'bold', display: 'block', marginTop: '10px' }}>
                                                        {readMoreText}
                                                    </a>
                                                </>
                                            );
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                    )}



                    <div className="textosagenda">
                        <p dangerouslySetInnerHTML={{ __html: excerpt }}></p>
                    </div>

                    <section className="sectponentes">
                        <div className="boxponentes">
                            <div className="carouselponentes">
                                <div className="gridspeakerstm">
                                    {speakers.map((item, index) => (
                                        <div className="card itemext" key={index} onClick={() => openModal(item)}>
                                            <div className="img">
                                                <img src={getImage(item.imagen)} alt={item.nombre} />
                                            </div>
                                            <div className="content">
                                                <div className="ponentedate">
                                                    <p><strong dangerouslySetInnerHTML={{ __html: item.nombre }}></strong></p>
                                                    <span dangerouslySetInnerHTML={{ __html: item.puesto }}></span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    );
};

export default Speakers;
